import { Graph, Node } from "../../models";
import { distanceType } from "../../models/types";

import { ActiveItemType, NodeLink } from "../../types";
import {
  SET_ACTIVE_ITEM,
  SET_ANSWERS,
  SET_DISTANCE_TYPE,
  SET_GRAPH,
} from "../reducers/graphReducer";

export const setGraph = (payload: Graph): { type: string; payload: Graph } => {
  return {
    type: SET_GRAPH,
    payload,
  };
};

export const setAnswers = (payload: any) => {
  return {
    type: SET_ANSWERS,
    payload,
  };
};

export const setActiveItem = (payload: ActiveItemType) => {
  return {
    type: SET_ACTIVE_ITEM,
    payload,
  };
};

export const setDistanceType = (payload: distanceType) => {
  return {
    type: SET_DISTANCE_TYPE,
    payload,
  };
};

export const addNode = (node: Node, graph: Graph) => {
  return (dispatch: any) => {
    const graphCopy = graph.copy();
    console.log("add");
    graphCopy.insertNode(node);
    dispatch(setGraph(graphCopy));
  };
};

export const onNodeClick = (
  node: Node,
  graph: Graph,
  activeItem: ActiveItemType,
  ctrl = false,
  delPressed = false
) => {
  return (dispatch: any) => {
    if (delPressed) {
      const graphCopy = graph.copy();
      graphCopy.removeNode(node);
      dispatch(setGraph(graphCopy));

      return;
    }
    if (
      ctrl &&
      activeItem &&
      activeItem.type === "NODE" &&
      node.name !== activeItem.node.name
    ) {
      const graphCopy = graph.copy();
      graphCopy.createPath(activeItem.node, 100, node);

      dispatch(setActiveItem(null));
      dispatch(setGraph(graph));
      return;
    }
    dispatch(
      setActiveItem({
        type: "NODE",
        node,
      })
    );
  };
};

export const byLinkClick = (
  link: NodeLink,
  graph: Graph,
  delPressed = false
) => {
  return (dispatch: any) => {
    if (delPressed) {
      const graphCopy = graph.copy();

      const { start, end } = link;
      const node = graphCopy.nodes[start.name];
      node.removeLink(end.name);

      dispatch(setGraph(graphCopy));
      return;
    }

    dispatch(
      setActiveItem({
        type: "LINK",
        link,
      })
    );
  };
};

export const clearAnswers = () => {
  return (dispatch: any) => {
    dispatch(setAnswers([]));
  };
};

export const changeGraph = (graph: Graph) => {
  return (dispatch: any) => {
    dispatch(setAnswers([]));
    dispatch(setGraph(graph));
  };
};

export const searchGraph = (
  graph: Graph,
  selectedNodes: string[],
  distanceType: distanceType
) => {
  return (dispatch: any) => {
    if (selectedNodes.length <= 1) return;

    const answers = selectedNodes.slice(1).map((node, index) => {
      const prev = selectedNodes[index];
      const a = graph.search(prev, node, distanceType);
      return a;
    });

    dispatch(setActiveItem(null));
    dispatch(setAnswers(answers));
  };
};
